import { FC, PropsWithChildren, createContext, useCallback, useContext, useEffect, useState } from 'react';

import { getCustomers } from 'services';
import { Customer } from 'types';

const CustomerContext = createContext<{
  customers: Customer[];
}>({
  customers: []
});

export const useCustomer = () => useContext(CustomerContext);

export const CustomerProvider: FC<PropsWithChildren> = ({ children }) => {
  const [customers, setCustomers] = useState<Customer[]>([]);

  const loadCustomers = useCallback(async () => {
    const customers = await getCustomers();
    setCustomers(customers);
  }, []);

  useEffect(() => {
    loadCustomers();
  }, [loadCustomers]);

  return <CustomerContext.Provider value={{ customers }}>{children}</CustomerContext.Provider>;
};
